/* eslint-disable react/prop-types */
import React from 'react';
import FontAwesome from 'react-fontawesome';
import SimpleButton from "../SimpleButton";
var AsyncButton = function AsyncButton(_ref) {
  var borderRadius = _ref.borderRadius,
    buttonColor = _ref.buttonColor,
    buttonDisabled = _ref.buttonDisabled,
    buttonHeight = _ref.buttonHeight,
    buttonHover = _ref.buttonHover,
    buttonWidth = _ref.buttonWidth,
    children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    fontAwesome = _ref.fontAwesome,
    loading = _ref.loading,
    onClick = _ref.onClick,
    onKeyDown = _ref.onKeyDown,
    ariaLabelText = _ref.ariaLabelText;
  return /*#__PURE__*/React.createElement(SimpleButton, {
    borderRadius: borderRadius,
    buttonColor: buttonColor,
    buttonDisabled: buttonDisabled,
    buttonHeight: buttonHeight,
    buttonHover: buttonHover,
    buttonWidth: buttonWidth,
    className: className,
    disabled: !!disabled,
    fontAwesome: fontAwesome,
    onClick: onClick,
    onKeyDown: onKeyDown,
    ariaLabelText: ariaLabelText
  }, loading ? /*#__PURE__*/React.createElement(FontAwesome, {
    name: "circle-o-notch",
    spin: true
  }) : children);
};
export default AsyncButton;